import { render, staticRenderFns } from "./PurchaseBonus.vue?vue&type=template&id=05b6e3f6&"
import script from "./PurchaseBonus.vue?vue&type=script&lang=js&"
export * from "./PurchaseBonus.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseBonus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports